import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgClose = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M15.0344 0.941162L0.94118 15.0344",
		stroke: "var(--icon-default-color, #0C5661)",
		strokeWidth: 1.5,
		strokeLinecap: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M0.965576 0.941162L15.0588 15.0344",
		stroke: "var(--icon-default-color, #0C5661)",
		strokeWidth: 1.5,
		strokeLinecap: "round"
	})]
});
export default SvgClose;
